import { useState } from 'react';
import { IconUp, IconDown } from '@ui/src';

import cn from './volumes-item.module.css';

const VolumesItem = ({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) => {
  const [collapsed, setCollapsed] = useState(true);

  return (
    <div className={cn.volumesItem}>
      <button
        type="button"
        className={cn.volumesTop}
        onClick={() => setCollapsed(!collapsed)}
      >
        {collapsed ? (
          <IconDown className={cn.volumesIcon} />
        ) : (
          <IconUp className={cn.volumesIcon} />
        )}
        {title}
      </button>
      {!collapsed && <div className={cn.volumesContent}>{children}</div>}
    </div>
  );
};

export default VolumesItem;
